import axios from 'axios';
import apiUrl from '../../constants';

export function SearchApi(input, token){
  return axios({
    method: 'post',
    url: apiUrl.api_url + 'searchshipments',
    data: input,
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
  }


// WEBPACK FOOTER //
// ./src/services/B2BModule/SearDataAPI.js